import React from 'react'
import PropTypes from 'prop-types'
import Typography from 'components/atoms/Typography'

const Faq = ({ question, children }) => (
  <div className="m-b-lg">
    <Typography variant="subheading" component="h3" className="m-b-sm font-bolder">
      {question}
    </Typography>
    <div>{children}</div>
  </div>
)

Faq.propTypes = {
  question: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
}

export default Faq
